module.exports = __webpack_public_path__ + "static/media/drums.06f4b73e.m4a";